import { render } from "./TypeChip.vue?vue&type=template&id=10b9f802"
import script from "./TypeChip.vue?vue&type=script&lang=js"
export * from "./TypeChip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__